"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardUseCase = void 0;
const phased_use_case_1 = require("../use-cases/phased-use-case");
/**
 * @/deprecated Use CommandUseCase or QueryUseCase instead. (@miguel - this has not been agreed to yet, there is active WIP on design here)
 */
class StandardUseCase extends phased_use_case_1.PhasedUseCase {
    async execute(input) {
        const loaded = await this._runPhase('load', input, () => this._load(input));
        const transformed = await this._runPhase('transform', loaded, () => this._transform(loaded));
        const saved = await this._runPhase('save', transformed, () => this._save(transformed));
        return {
            loaded,
            transformed,
            saved,
        };
    }
    /**
     * Preview the use case result without saving to database.
     * Runs _load and _transform phases but skips _save.
     * Useful for showing users what changes would be made before committing.
     */
    async preview(input) {
        const loaded = await this._runPhase('load', input, () => this._load(input));
        const transformed = await this._runPhase('transform', loaded, () => this._transform(loaded));
        return {
            loaded,
            transformed,
        };
    }
}
exports.StandardUseCase = StandardUseCase;
